import { BudgetType, SizeType, StyleType } from './types'

export const MAX_BUDGET = 1000000
export const MIN_BUDGET = 0
export const MAX_SIZE = 1000
export const MIN_SIZE = 0
export const IndividualBudgetType: BudgetType[] = [
  {
    label: 'Less than $100',
    min: 0,
    max: 100,
  },
  {
    label: '$100 - $500',
    min: 100,
    max: 500,
  },
  {
    label: '$500 - $1,000',
    min: 500,
    max: 1000,
  },
  {
    label: '$1,000 - $5,000',
    min: 1000,
    max: 5000,
  },
  {
    label: 'More than $5,000',
    min: 5000,
    max: MAX_BUDGET,
  },
  {
    label: 'Custom budget',
    min: null,
    max: null,
    isOther: true,
  },
]

export const SIZE_TYPES: SizeType[] = [
  {
    label: 'Small (0-18”)',
    value: '0-18',
    size: 'S',
  },
  {
    label: 'Medium (18-36”)',
    value: '18-36',
    size: 'M',
  },
  {
    label: 'Large (36-60”)',
    value: '36-60',
    size: 'L',
  },
  {
    label: 'Extra Large (60-84”)',
    value: '60-84',
    size: 'XL',
  },
  {
    label: 'Oversized (84”+)',
    value: '84',
    size: 'OS',
  },
]
export const SIZES_GUIDE = [
  {
    size: 'S',
    inches: '0” - 18”',
    cm: '0 cm - 45 cm',
  },
  {
    size: 'M',
    inches: '18” - 36”',
    cm: '45 cm - 91 cm',
  },
  {
    size: 'L',
    inches: '36” - 60”',
    cm: '91 cm - 152 cm',
  },
  {
    size: 'XL',
    inches: '60” - 84”',
    cm: '152 cm - 214 cm ',
  },
  {
    size: 'OS',
    inches: '84” +',
    cm: '214 cm +',
  },
]

export const FIND_ART_STYLES_TYPES: StyleType[] = [
  {
    label: 'Abstract',
    value: 'abstract',
    ratio: '6/6',
    image: '/images/find-art/abstract.webp',
    imageSmall: '/images/find-art/abstract-tiny.png',
  },
  {
    label: 'Figurative',
    value: 'figurative',
    ratio: '6/6',
    image: '/images/find-art/figurative.webp',
    imageSmall: '/images/find-art/figurative-tiny.png',
  },
  {
    label: 'Portrait',
    value: 'portrait',
    ratio: '6/6',
    image: '/images/find-art/portraiture.webp',
    imageSmall: '/images/find-art/portraiture-tiny.png',
  },
  {
    label: 'Geometric',
    value: 'geometric',
    ratio: '6/6',
    image: '/images/find-art/geometric.webp',
    imageSmall: '/images/find-art/geometric-tiny.png',
  },
  {
    label: 'Landscape',
    value: 'landscape',
    ratio: '6/6',
    image: '/images/find-art/landscape.webp',
    imageSmall: '/images/find-art/landscape-tiny.png',
  },
  {
    label: 'Urban',
    value: 'urban',
    ratio: '6/6',
    image: '/images/find-art/urban.webp',
    imageSmall: '/images/find-art/urban-tiny.png',
  },
  {
    label: 'Typography',
    value: 'typography',
    ratio: '6/6',
    image: '/images/find-art/typography.webp',
    imageSmall: '/images/find-art/typography-tiny.png',
  },
  {
    label: 'Drawing',
    value: 'drawing',
    ratio: '6/6',
    image: '/images/find-art/drawing.webp',
    imageSmall: '/images/find-art/drawing-tiny.png',
  },
  {
    label: 'Painting',
    value: 'painting',
    ratio: '6/6',
    image: '/images/find-art/painting.webp',
    imageSmall: '/images/find-art/painting-tiny.png',
  },
  {
    label: 'Photography',
    value: 'photography',
    ratio: '6/6',
    image: '/images/find-art/photography.webp',
    imageSmall: '/images/find-art/photography-tiny.png',
  },
  {
    label: 'Illustration',
    value: 'illustration',
    ratio: '6/6',
    image: '/images/find-art/illustration.webp',
    imageSmall: '/images/find-art/illustration-tiny.png',
  },
  {
    label: 'Printmaking',
    value: 'printmaking',
    ratio: '6/6',
    image: '/images/find-art/printmaking.webp',
    imageSmall: '/images/find-art/printmaking-tiny.png',
  },
  {
    label: 'Still Life',
    value: 'still-life',
    ratio: '6/6',
    image: '/images/find-art/still-life.webp',
    imageSmall: '/images/find-art/still-life-tiny.png',
  },
  {
    value: 'Minimalism',
    label: 'Minimalism',
    ratio: '6/6',
    image: '/images/find-art/minimalism.webp',
    imageSmall: '/images/find-art/minimalism-tiny.png',
  },

  {
    label: 'Hyperrealism',
    value: 'hyperrealism',
    ratio: '6/6',
    image: '/images/find-art/hyperrealism.webp',
    imageSmall: '/images/find-art/hyperrealism-tiny.png',
  },

  {
    label: 'Realism',
    value: 'realism',
    ratio: '6/6',
    image: '/images/find-art/realism.webp',
    imageSmall: '/images/find-art/realism-tiny.png',
  },

  {
    label: 'Surrealism',
    value: 'surrealism',
    ratio: '6/6',
    image: '/images/find-art/surrealism.webp',
    imageSmall: '/images/find-art/surrealism-tiny.png',
  },

  {
    label: 'Impressionism',
    value: 'impressionism',
    ratio: '6/6',
    image: '/images/find-art/impressionism.webp',
    imageSmall: '/images/find-art/impressionism-tiny.png',
  },

  {
    label: 'Expressionism',
    value: 'expressionism',
    ratio: '6/6',
    image: '/images/find-art/expressionism.webp',
    imageSmall: '/images/find-art/expressionism-tiny.png',
  },

  {
    label: 'Cubism',
    value: 'cubism',
    ratio: '6/6',
    image: '/images/find-art/cubism.webp',
    imageSmall: '/images/find-art/cubism-tiny.png',
  },
  {
    label: 'Pop Art',
    value: 'pop-art',
    ratio: '6/6',
    image: '/images/find-art/pop-art.webp',
    imageSmall: '/images/find-art/pop-art-tiny.png',
  },
  {
    label: 'Street Art',
    value: 'street-art',
    ratio: '6/6',
    image: '/images/find-art/street-art.webp',
    imageSmall: '/images/find-art/street-art-tiny.png',
  },

  {
    label: 'Conceptual Art',
    value: 'conceptual-art',
    ratio: '6/6',
    image: '/images/find-art/conceptual-art.webp',
    imageSmall: '/images/find-art/conceptual-art-tiny.png',
  },
]
